import React from 'react';
import TreeComponent from "../CommonComponents/TreeComponent";
import {Label} from '@fluentui/react';
import { connect } from "react-redux";
import NewModal from "./NewModal";
import {setGeoChoice} from "../../../actions/CreateSiteActions/dimensionActions";
import {ItemPicker} from "../CommonComponents/ItemPicker";
import Warning from '../CommonComponents/Warning';
import Api from '../../../services/Api'

/*const CROSS_ORGANIZATION = 'CrossOrganization';*/

class Geography extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            firstLevel: []
        }
    }

    componentDidMount() {
        
        if (!this.props.selectedGeo && this.props.geographyConfig.defaultKey) {
            this.fitDefaultChoice(this.props.geographyConfig.defaultKey);
        }

        if (!this.props.geographyConfig.isDisabled) {
            this.fitPossibilities();
        }
    }

    fitDefaultChoice(defaultKey) {
        Api.get(`/Geography?key=${defaultKey}`)
            .then(res => res.data)
            .then(posts => {
                const post = posts.find(x => x.key === this.props.geographyConfig.defaultKey);
                this.props.setGeography(post);
            });
    }

    fitPossibilities() {
        Api.get(`/Geography?${this.props.geographyConfig.onlyChildrenAllowed ? `key=${this.props.geographyConfig.defaultKey}&parent=all` : 'parent=abb'}`)
            .then(res => res.data)
            .then(posts => {
                this.setState({firstLevel: posts});
            });
    }

    isValid() {
        return !!this.props.selectedGeo;
    }

    render() {

        let fulladdressSearch = `/Geography?${this.props.geographyConfig.onlyChildrenAllowed ? `parent=${this.props.geographyConfig.defaultKey}&` : ''}search=`;
        let fulladdressTree = '/Geography'
        let geo = this.state.firstLevel.map(item =>
            <TreeComponent
                key={item.key}
                child={item}
                itemSelector={this.props.setGeography}
                selectedItem={this.props.selectedGeo}
                url={fulladdressTree}
            />)
        geo = <div className="tree"> {geo} </div>
        const warning = this.props.possibleWarning && !this.isValid() ?  <Warning element="nolabel-basepicker"/> : null;
        const error = warning && <div className='errorMessage'>Please select an option</div>;
        return (
            <div>
                <div>
                    <div className="geography-panel">
                            {warning}
                        {/* <div style={{marginTop:'20px', marginBottom:'20px'}}> Select Site Location</div> */}
                        <ItemPicker
                            itemSelector = {this.props.setGeography}
                            searchTitle = "Search for Country or Region"
                            url = {fulladdressSearch}
                            selection = {this.props.selectedGeo}
                            styles = {{fontSize:'14px', fontWeight:'normal'}}
                            isPickerDisabled = {this.props.geographyConfig.isDisabled}
                        />
                        <Label style={{marginTop:'10px'}}>Or select item from tree</Label>
                        <NewModal 
                            component = {geo} 
                            selection = {this.props.selectedGeo} 
                            isPickerDisabled = {this.props.geographyConfig.isDisabled} />
                        {error}
                    </div>
                </div>
            </div>
        );
    }
}

const mapActionToProp = {
    setGeography: setGeoChoice
}

const mapStateToProps = state => ({
    selectedGeo: state.newSite.geography,
    possibleWarning: state.wizard.nextStepRequested,
    geographyConfig: (state.newSite.Template.config || {}).geographyConfig || {}
})

export default connect(mapStateToProps, mapActionToProp)(Geography)








// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/Geography.js